import React from "react";

const PlusIcon = () => {
  return (
    <>
      <svg width="23" height="23" viewBox="0 0 23 23">
        <g
          id="Icon_feather-plus"
          data-name="Icon feather-plus"
          transform="translate(-6.5 -6.5)"
        >
          <path
            id="Path_2536"
            data-name="Path 2536"
            d="M18,7.5v21"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_2537"
            data-name="Path 2537"
            d="M7.5,18h21"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </svg>
    </>
  );
};

export default PlusIcon;
